<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>

                <!-- Titulo -->
                <TituloPagina titulo="Categorias" />

                <!-- Fitro de pesquisa e Dialog de nova categoria. -->
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-text-field
                                flat
                                solo
                                prepend-icon="search"
                                placeholder="Filtro"
                                v-model="search"
                                hide-details
                            ></v-text-field>
                            <CategoriasModal :reloadGrid="getCategorias" />
                        </v-toolbar>
                        <v-divider></v-divider>

                        <!-- Data table -->
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="categorias.headers"
                                :search="search"
                                :items="categorias.items"
                                :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
                                :loading="loading"
                                :no-data-text="semDados"
                                class="elevation-1"
                                item-key="name"
                            >
                                <template slot="items" slot-scope="props">
                                    <td xs1>#{{ props.item.orbiter_id }}</td>
                                    <td xs8>{{ props.item.nome }}</td>
                                    <td xs1>
                                        <v-chip
                                            small
                                            text-color="white"
                                            :color="props.item.positivo ? 'success' : 'error'"
                                        >{{ props.item.positivo ? 'Positivo' : 'Negativo' }}</v-chip>
                                    </td>
                                    <td xs1>
                                        <v-chip
                                            small
                                            text-color="white"
                                            :color="props.item.ativa ? 'success' : 'error'"
                                        >{{ props.item.ativa ? 'Sim' : 'Não' }}</v-chip>
                                    </td>
                                    <td xs1 class="no-wrap text-xs-right">
                                        <CategoriasModal :reloadGrid="getCategorias" :categoria="props.item" />
                                        <ExcluirModal :reloadGrid="getCategorias" :id="props.item._id" :route="route" />
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import TituloPagina    from '@/components/crud/TituloPagina';
import ExcluirModal    from '@/components/crud/ExcluirModal';
import CategoriasModal from './CategoriasModal';

export default {
    name       : 'Categorias',
    components : {
        TituloPagina,
        ExcluirModal,
        CategoriasModal
    },
    computed   : {
        semDados() {
            return this.loading ? 'Buscando informações...' : 'Nenhuma categoria cadastrada';
        }
    },
    methods    : {
        getCategorias() {
            this.loading = true;
            this.$axios.get(this.route).then(response => {
                // console.log('getCategorias():', response.data);
                this.categorias.items = response.data.items;
                this.loading = false;
            });
        }
    },
    data() {
        return {
            loading    : true,
            search     : '',
            route      : 'categorias',
            categorias : {
                headers : [
                    {
                        text     : 'Orbiter #',
                        value    : 'orbiter_id'
                    },
                    {
                        text     : 'Nome',
                        value    : 'nome'
                    },
                    {
                        text     : 'Sinal',
                        value    : 'positivo'
                    },
                    {
                        text     : 'Ativa',
                        value    : 'ativa'
                    },
                    {
                        text     : 'Ações',
                        align    : 'center',
                        width    : 1,
                        sortable : false,
                        value    : ''
                    }
                ],
                items   : []
            }
        };
    },
    mounted() {
        this.getCategorias();
    }
};
</script>
